/* eslint-disable no-lone-blocks */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';

import Slider from "react-slick";
import 'idempotent-babel-polyfill';
import Footer from './Footer';
import { get_json } from './common';
import { createBrowserHistory } from 'history';
import { connect } from 'react-redux';
import { api, basic_api } from './common';
import "react-responsive-carousel/lib/styles/carousel.min.css";

import { Carousel } from 'react-responsive-carousel';
import Loader from './Loader'
import { useImage } from 'react-image'

import { Suspense } from 'react';
import { BussinessComponent } from './Component/BussinessComponent'
import { HomeCollectionComponent } from './Component/HomeCollectionComponent'
import { FullBannerComponent } from './Component/FullBannerComponent'
import { TestinomialComponent } from './Component/TestinomialComponent'
import { SliderImageComponent } from './Component/SliderImageComponent'
import { BannerComponent } from './Component/BannerComponent'
var properties = { dots: false, infinite: false, slidesToShow: 1, slidesToScroll: 1, arrows: false, };
var properties_new_collection_slider = {
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    responsive: [
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                swipe: true,
                draggable: true,
            }
        },
        {
            breakpoint: 481,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                swipe: true,
                draggable: true,
            }
        },
    ]
}
var properties_slider = {
    dots: true,
    infinite: true,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 3000,
    responsive: [
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                swipe: true,
                draggable: true,
            }
        },
        {
            breakpoint: 481,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                swipe: true,
                draggable: true,
            }
        },
    ]
}






class Home extends Component {
    constructor(props) {
        super(props);
        this.state = { data: [], is_footer: false, loader: true, email_loader: false, email: "", emailerror: "" };
        this.collection = React.createRef();
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
    }

    async componentDidMount() {
        window.scrollTo(0, 0)
        if (this.props.alldata === null) {
            await get_json(this)
            this.props.setresponseJson(this.state.data)
        } else {
            await this.setState({ data: this.props.alldata })
        }
        let slider_arr = [];
        if (this.state.data !== "invalid") {
            if (this.state.data.slider !== '' || this.state.data.slider !== undefined || this.state.data.slider !== null) {
                this.state.data.slider.forEach((item, i) => {
                    //  console.log("item   sdsd",item)
                    slider_arr.push(<SliderImageComponent item={item} index={i} onClick={(data) => { this.redirect_page(data) }}></SliderImageComponent>);
                });
                this.setState({ slider_arr: slider_arr });
            }
            setTimeout(() => {
                if (this.state.data != '' && this.state.data != undefined && this.state.data != null) {
                    this.setState({ is_footer: true });
                }
            }, 2000);


            if (this.state.data !== '' || this.state.data !== undefined || this.state.data !== null) {
                let template_json = JSON.parse(this.state.data.template_json);
                console.log(template_json, "template_json")
                const blockTypeArr = [];
                for (var i = 0; i < template_json.length; i++) {
                    blockTypeArr.push(template_json[i]['type']);
                }
                this.setState({ "blockTypeArr": blockTypeArr });
            }


            let about_bussiness = [];
            let bussiness = this.state.data.bussiness;
            if (typeof bussiness !== 'undefined') {
                if (bussiness.length > 0) {
                    bussiness.forEach((item, i) => {
                        console.log(item, "item about_bussiness")
                        about_bussiness.push(<BussinessComponent item={item} index={i} onClick={(data) => { this.redirect_page(data) }}></BussinessComponent>);
                    });
                    this.setState({ about_bussiness: about_bussiness });
                }
            }


            let collection_data = [];
            let collection = this.state.data.collection;
            if (typeof collection !== 'undefined') {
                if (collection.length > 0) {
                    collection.forEach((item, i) => {
                        console.log(item,"HomeCollectionComponent")
                        collection_data.push(<HomeCollectionComponent item={item} _onClick={(data) => { this.props.history.push({ pathname: "/" + data }) }}></HomeCollectionComponent>);
                    });

                    this.setState({ collection_data: collection_data });
                }
            }


            var banner = this.state.data['banner'];
            if (typeof banner !== 'undefined') {
                this.setState({ banner_title: banner.title, banner_content: banner.content, banner_image: banner.image, banner_button: banner.button });
            }

            var testinomial = this.state.data['banner'];
            if (typeof testinomial !== 'undefined') {
                var testinomial_arr = []
                this.state.data.review.map((item, i) => {
                    testinomial_arr.push(<TestinomialComponent item={item}></TestinomialComponent>)
                }
                )
                this.setState({ testinomial_arr })
            }


            let blocks = this.state.blockTypeArr;
            let renderArr = [];
            if (blocks !== undefined && blocks.length > 0) {
                for (let b = 0; b < blocks.length; b++) {
                    switch (blocks[b]) {
                        case 'bussiness':
                            var elem = {};
                            elem.type = "bussiness";
                            elem.value = <div ref={this.collection} className='elemColle w-left'>{this.state.about_bussiness} </div>
                            renderArr.push(elem);
                            break;
                        case 'collection':
                            elem = {};
                            elem.type = "collection";
                            elem.value =
                                <div className="new_collection w-left">
                                    <div className="container">
                                        <div className="row">
                                            <div className="jewe_title">
                                                <h3>What new to looking you ?</h3>
                                                <p>Jewellery may be made from a wide range of materials. Gemstones and similar materials have been widely used, and enamel has been important.</p>
                                            </div>

                                            {(this.state.data.collection !== null && this.state.data.collection !== undefined && this.state.data.collection.length > 0) &&
                                                <Slider {...properties_new_collection_slider} className="new_collection_slider">
                                                    {this.state.collection_data}
                                                </Slider>
                                            }

                                        </div>
                                    </div>
                                </div>
                            renderArr.push(elem);
                            break;

                        case 'full_banner':
                            elem = {};
                            elem.type = "banner";
                            elem.value = <FullBannerComponent item={this.state.data['full_banner']} onClick={() => { this.props.history.push({ pathname: "/about" }) }}></FullBannerComponent>
                            renderArr.push(elem);
                            break;
                        case 'testinomial':
                            elem = {};
                            elem.type = "testinomial";
                            elem.value =
                                <div className="customer-review w-left">
                                    <div className="container">
                                        <div className="jewe_title">
                                            <h3>Customer Reviews</h3>
                                            <p>We’re more than a piece of jewelry & make true connections.</p>
                                        </div>



                                        <div class="test-m-slider arrw-blck">


                                            {(this.state.data.review !== null && this.state.data.review !== undefined && this.state.data.review.length > 0) &&
                                                <Slider {...properties} ref={c => (this.slider = c)}>
                                                    {this.state.testinomial_arr}
                                                </Slider>
                                            }

                                        </div>

                                        <ul className="prevNext list-inline">
                                            <li className="prev slick-arrow" aria-disabled="false" style={{}} onClick={this.previous}>
                                                <svg viewBox="0 0 512.008 512.008">
                                                    <path d="M501.342 245.185H36.424L210.227 71.404c4.093-4.237 3.975-10.99-.262-15.083-4.134-3.992-10.687-3.992-14.82 0l-192 192c-4.171 4.16-4.179 10.914-.019 15.085l.019.019 192 192c4.093 4.237 10.845 4.354 15.083.262 4.237-4.093 4.354-10.845.262-15.083a10.787 10.787 0 00-.262-.262L36.424 266.519h464.917c5.891 0 10.667-4.776 10.667-10.667s-4.775-10.667-10.666-10.667z" fill="#2196f3" />
                                                    <path d="M202.675 458.519a10.663 10.663 0 01-7.552-3.115l-192-192c-4.164-4.165-4.164-10.917 0-15.083l192-192c4.237-4.093 10.99-3.975 15.083.262 3.992 4.134 3.992 10.687 0 14.82L25.758 255.852 210.206 440.3c4.171 4.16 4.179 10.914.019 15.085a10.672 10.672 0 01-7.55 3.134z" />
                                                    <path d="M501.342 266.519H10.675c-5.891 0-10.667-4.776-10.667-10.667s4.776-10.667 10.667-10.667h490.667c5.891 0 10.667 4.776 10.667 10.667s-4.776 10.667-10.667 10.667z" />
                                                </svg>
                                            </li>
                                            <li className="next slick-arrow slick-disabled" aria-disabled="true" style={{}} onClick={this.next}>
                                                <svg viewBox="0 0 512 512">
                                                    <path d="M511.189 259.954a10.667 10.667 0 00-2.325-11.627l-192-192c-4.237-4.093-10.99-3.975-15.083.262-3.992 4.134-3.992 10.687 0 14.82l173.803 173.803H10.667C4.776 245.213 0 249.989 0 255.88c0 5.891 4.776 10.667 10.667 10.667h464.917L301.803 440.328c-4.237 4.093-4.355 10.845-.262 15.083 4.093 4.237 10.845 4.354 15.083.262.089-.086.176-.173.262-.262l192-192a10.693 10.693 0 002.303-3.457z" fill="#2196f3" />
                                                    <path d="M309.333 458.546a10.667 10.667 0 01-7.552-18.219l184.47-184.447-184.47-184.448c-4.093-4.237-3.975-10.99.262-15.083 4.134-3.992 10.687-3.992 14.82 0l192 192c4.164 4.165 4.164 10.917 0 15.083l-192 192a10.66 10.66 0 01-7.53 3.114z" />
                                                    <path d="M501.333 266.546H10.667C4.776 266.546 0 261.771 0 255.88s4.776-10.667 10.667-10.667h490.667c5.891 0 10.667 4.776 10.667 10.667-.001 5.891-4.777 10.666-10.668 10.666z" />
                                                </svg>
                                            </li>
                                        </ul>
                                    </div>


                                </div>
                            renderArr.push(elem);
                            break;
                        case 'banner':
                            elem = {};
                            elem.type = "banner";
                            elem.value = <BannerComponent banner_title={this.state.banner_title} banner_content={this.state.banner_content} banner_image={this.state.banner_image} banner_button={this.state.banner_button} emailerror={this.state.emailerror} onClick={(e) => { this.get_subscribe(e) }} onChange={async (e) => {
                                await this.setState({ email: e.target.value, emailerror: "" }, async () => {
                                    await this.updatebanner();
                                })
                            }}></BannerComponent>;
                            renderArr.push(elem);

                            break;
                        default:
                            break;
                    }
                }
                this.setState({ "renderArr": renderArr });
            }
        }
        this.setState({ "loader": false });
    }
    redirect_page(title) {
        this.props.history.push({ pathname: "/" + title, state: { title: title } });
    }
    next() {
        this.slider.slickNext();
    }
    previous() {
        this.slider.slickPrev();
    }
    get_subscribe = async (e) => {
        e.preventDefault();
        var email = this.state.email;
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        re.test(email);
        if (re.test(email)) {
            await this.setState({ email_loader: true })
            var data = new FormData();
            data.append("action", "user_subscribe")
            data.append("sub_u_id", this.props.alldata.user_id)
            data.append("sub_u_email", this.state.email)
            const requestOptions = {
                method: 'post',
                body: data
            };

            fetch(api + basic_api, requestOptions)
                .then((response) => response.json())
                .then(async (responseJson) => {



                    await this.setState({ emailerror: "Thanks for subscription", email: '', email_loader: false }, () => {
                        this.updatebanner();
                    })

                })
                .catch((error) => {
                    console.log(error, "error")
                });

        } else {
            await this.setState({ emailerror: "Please enter valid email", email_loader: false }, () => {
                this.updatebanner();
            })
        }
    }
    handlechnage = async (e) => {
        await this.setState({ email: e.target.value }, () => {


        });
    }
    updatebanner = () => {
        var renderArr = this.state.renderArr;
        renderArr.map((item, index) => {
            if (item.type == "banner") {
                item.value = <div className="newslatter-sec w-left" style={{ backgroundImage: 'url(' + this.state.banner_image + ')', backgroundSize: 'cover', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat' }}>
                    <div className="left-img-news">
                        <div className="bg-left-news" >
                        </div>
                    </div>
                    <div className="right-side-form">
                        <div className="inner-right-side-f">
                            <h3 className="wthree_text_info">{this.state.banner_title}</h3>
                            <p>{this.state.banner_content}</p>
                            <form>
                                <input type="email" name="Email" placeholder="Email" onChange={async (e) => {
                                    {
                                        await this.setState({ email: e.target.value, emailerror: "" }, async () => {
                                            await this.updatebanner();
                                        })
                                    }
                                }} value={this.state.email} />

                                <button type="submit" className="hvr-outline-out button2 sub-newlter" onClick={(e) => { this.get_subscribe(e) }} disabled={this.state.email_loader} style={this.state.email_loader ? { "opacity": '0.4' } : {}}>{this.state.banner_button}</button>
                                <p className="Erro_msg">{this.state.emailerror}</p>
                            </form>
                        </div>
                    </div>
                </div>
            }
        })

        this.setState({ "renderArr": renderArr });
    }
    render() {
        let renderArr = this.state.renderArr;
        return (
            <div>
                {this.state.data !== "invalid" && <Suspense fallback={<Loader></Loader>}>
                    <div>
                        <div className="img-slideshow p-relative w-left">
                            <Slider  {...properties_slider} className={"slider_home"}>
                                {this.state.slider_arr}
                            </Slider>
                        </div>
                        {(renderArr !== undefined && renderArr.length > 0 && renderArr !== null) &&
                            renderArr.map((block, i) => (
                                <div key={i}>
                                    {block.value}
                                </div>
                            ))
                        }
                        {(this.state.is_footer) &&
                            <Footer />
                        }
                    </div>
                </Suspense>}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    console.log(state, "state")
    return {
        alldata: state.responseJson,

    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        setresponseJson: (data) => dispatch({ type: "ALL_RESPONSE", payload: data }),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Home);
